import React from 'react';

import './style.scss';

export const ScheduleBoardOnline = ({}) => {
    return (<></>)
};
